import moment from 'moment-timezone'
import { isObjectId, objectIdToTimestamp } from '@/utils/format'

export default function (value, timezone = false) {
	if (!value) { return '' }
	const date = moment(isObjectId(value) ? objectIdToTimestamp(value) : value).utc()

	if (timezone) {
		const tz = timezone === true ? moment.tz.guess() : timezone
		date.tz(tz)
	}

	return date.format(`YYYY-MM-DD HH:mm:ss${timezone ? ' z' : ''}`)
}
